import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

function isAuthenticated(): boolean {
  return Boolean(localStorage.getItem('auth_token'));
}

export default function ProtectedRoute({ children }: { children: React.ReactElement }) {
  const location = useLocation();
  if (isAuthenticated()) return children;
  return <Navigate to="/login" replace state={{ from: location.pathname }} />;
}
